<template>
  <div class="generalize">
    <div class="generalize-way">
      <template v-for="(item, index) in generalizeWay">
        <div class="way-item" :key="index">
          <div class="way-item-title" :style="{ 'color': item.color }">
            <img :src="item.imgurl" alt />
            <span>{{ item.title }}</span>
          </div>
          <div class="way-item-hint">{{ item.hint }}</div>
          <p class="way-item-hint" style="color:#8D8B8E">{{ item.cont }}</p>
          <div
            class="way-item-button"
            :style="{ 'color': item.color,'borderColor': item.color}"
          >立即加入</div>
        </div>
      </template>
    </div>

    <div class="join-form">
      <div class="join-form-head">预约您的专属营销顾问</div>
      <div class="join-form-name">
        姓名
        <el-input placeholder v-model="input1" style="width:300px;margin-left:8px"></el-input>
      </div>
      <div class="join-form-name">
        电话
        <el-input placeholder v-model="input1" style="width:300px;margin-left:8px"></el-input>
      </div>
      <div class="join-form-button">立即进入</div>
      <div class="join-form-hint">您也可以拨打我们的免费咨询电话，详细了解我们为您定制的推广方案</div>
      <div class="join-form-phone join-form-hint"><span>咨询电话：</span><span style="color:#2F54EB">{{phoneNum}}</span></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data() {
    return {
      input1: "",
      phoneNum: "188 8821 7968",
      generalizeWay: [
        {
          title: "微信朋友圈广告",
          imgurl: require("../../../../public/img/pyqtb.png"),
          hint: "指出现在微信朋友圈的广告",
          cont:
            "广告融入生活场景，让用户指导，喜欢您的品牌，通过互动链接品牌与用户，提升品牌认知并传播。",
          color: "#F37520"
        },
        {
          title: "微信公众号广告",
          imgurl: require("../../../../public/img/gzhtb.png"),
          hint: "指出现在微信公众号文章底部的广告",
          cont:
            "以收章内容的形式出现在公众号文章中,支持多维度组合定向投放,实现高效率转化。",
          color: "#6CCF26"
        },
        {
          title: "普通展示广告",
          imgurl: require("../../../../public/img/txwtb.png"),
          hint:
            "指出现QQ空间、QQ客户端、 手机QQ浏览器、应用宝、腾讯新闻、腾讯视频应用的广告",
          cont: "贯穿用户每日24小时真实生活。",
          color: "#3E97DA"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.generalize {
  height: 100%;
  overflow: auto;
  background: #f0f2f5;
  padding: 30px 20px 20px;

  .generalize-way {
    height: 250px;
    display: flex;
    .way-item {
      min-width: 400px;
      flex: 1;
      height: 100%;
      background: #fff;
      padding: 20px 35px;

      .way-item-title {
        font-size: 17px;
        text-align: center;
        height: 34px;
        line-height: 34px;
        position: relative;

        img {
          width: 34px;
          height: 34px;
          position: absolute;
          left: 20%;
        }
      }

      .way-item-hint {
        text-align: center;
        margin-top: 20px;
        font-size: 14px;
        color: #545356;
      }

      .way-item-button {
        width: 140px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        border: 1px solid;
        margin: 0 auto;
        margin-top: 20px;
        border-radius: 5px;
      }
    }
    .way-item:nth-child(1),
    .way-item:nth-child(2) {
      margin-right: 15px;
    }
  }

  .join-form {
    margin-top: 20px;
    background: #fff;
    padding-top: 80px;
    padding-bottom: 80px;

    .join-form-head {
      text-align: center;
      height: 24px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
    }

    .join-form-name {
      margin-top: 40px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
    }

    .join-form-button {
      width: 120px;
      height: 32px;
      border-radius: 3px;
      border: 1px solid rgba(47, 84, 235, 1);
      text-align: center;
      margin: 0 auto;
      line-height: 32px;
      margin-top: 40px;
      color: rgba(47, 84, 235, 1);
    }

    .join-form-hint {
      height: 18px;
      font-size: 13px;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.45);
      line-height: 18px;
      margin-top: 30px;
      text-align: center;
    }

    .join-form-phone {
      color:rgba(0,0,0,0.85);
      font-size:16px;
    }
  }
}
</style>
